import { Link } from 'react-router';
import { useT } from '@/i18n';

export function NotFoundPage() {
  const { t } = useT();
  return (
    <div className="flex flex-col items-center justify-center px-4 py-24 text-center">
      <h1 className="text-4xl font-bold text-foreground">404</h1>
      <p className="mt-2 text-muted">{t('routes.misc.notFoundPage.pageNotFound')}</p>
      <Link to="/" className="mt-4 text-primary hover:underline">{t('routes.misc.notFoundPage.backToTheDashboard')}</Link>
    </div>
  );
}
